import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Text, BackLink } from 'view/atoms';
import { ROUTES } from 'config';
import * as S from './Page404.styles';

export const Page404 = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(ROUTES.main);
  };

  return (
    <S.Page404Styled>
      <BackLink action={() => navigate(-1)} />
      <S.PageContent>
        <S.ErrorHeader kind='h1' color='white'>
          404
        </S.ErrorHeader>
        <S.ErrorSubheader kind='h2' color='gray1'>
          {t('page404.errorDescribeHeader')}
        </S.ErrorSubheader>
        <S.ErrorDescription kind='body' color='gray1'>
          {t('page404.errorDescribeSubheader')}
        </S.ErrorDescription>
        <S.GoHomeButton type='submit' kind='primary' onClick={handleClick}>
          <Text kind='button' color='gray1'>
            {t('page404.goHome')}
          </Text>
        </S.GoHomeButton>
      </S.PageContent>
    </S.Page404Styled>
  );
};
